import { useNavigate } from 'react-router-dom'
import type { Region, RegionType } from '@/types'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

interface RegionCardProps {
  region: Region
}

const regionTypeLabels: Record<RegionType, string> = {
  coastal: 'Coastal',
  mountain: 'Mountain',
  plains: 'Plains',
  forest: 'Forest',
  urban_core: 'Urban Core',
}

function formatPopulation(population: number): string {
  return population.toLocaleString()
}

export function RegionCard({ region }: RegionCardProps) {
  const navigate = useNavigate()

  return (
    <Card
      className="cursor-pointer transition-shadow hover:shadow-md"
      onClick={() => navigate(`/regions/${region.id}`)}
    >
      <CardHeader>
        <div className="flex items-start justify-between gap-2">
          <CardTitle className="text-lg">{region.name}</CardTitle>
          <Badge variant="secondary">{regionTypeLabels[region.region_type]}</Badge>
        </div>
        <CardDescription>Click to view region details</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-1 text-sm">
          <div>
            <span className="text-muted-foreground">Seats:</span>{' '}
            <span className="font-medium">{region.seat_count}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Population:</span>{' '}
            <span className="font-medium">{formatPopulation(region.population)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
